import type { AppProps } from 'next/app';
import '@/styles/globals.css';
import Script from 'next/script';
import { ColorsProvider } from '../hooks/useColors';
import InstallPWA from '@/components/InstallPWA';

const App = ({ Component, pageProps }: AppProps) => {
  return (
    <ColorsProvider>

    <Script strategy="afterInteractive" src="https://www.googletagmanager.com/gtag/js?id=G-5MKD5VG3H8" />
    <Script id="google-analytics" strategy="afterInteractive">
      {`
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-5MKD5VG3H8');
      `}
    </Script>

    {/* Facebook Pixel Code 
    <Script strategy="afterInteractive" src="https://connect.facebook.net/en_US/fbevents.js" />
    <Script strategy="afterInteractive" id="facebook-pixel">
        {`
          !function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', 'YOUR_PIXEL_ID');
          fbq('track', 'PageView');
        `}
      </Script>*/}
{/**      <noscript>
        <img height="1" width="1" style="display:none"
          src="https://www.facebook.com/tr?id=YOUR_PIXEL_ID&ev=PageView&noscript=1"/>
      </noscript>
    <InstallPWA /> */}
    <Component {...pageProps} />

    </ColorsProvider>
  );
};

export default App;
